/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";

import styles from "./SideEqualizer.module.css";
import { type ParticipantConnectionQuality } from "../state/MediaViewModel";

interface Props {
  /** Прыгает, пока участник говорит; иначе стоит смирно на нижнем делении. */
  active: boolean;
  connectionQuality?: ParticipantConnectionQuality;
  miniature?: boolean;
}

/**
 * Ретро-эквалайзер сбоку от плитки участника (CTO 04.09.2026: «сбоку у них прыгает
 * эквалайзер громкости и качества соединения», в пару к ЭЛТ-скруглению кадра). Полосы
 * анимируются, пока идёт речь, а цвет столбиков берётся из той же шкалы качества связи,
 * что и обычный индикатор сигнала — так одна и та же полоска читается и как «говорит»,
 * и как «на каком канале связи».
 *
 * Чисто декоративный слой: и речь, и качество связи уже озвучены другими элементами
 * плитки (иконка микрофона, кольцо вокруг говорящего, индикатор связи), поэтому
 * скринридеру эта полоска не нужна — aria-hidden.
 */
export const SideEqualizer: FC<Props> = ({
  active,
  connectionQuality = "unknown",
  miniature = false,
}) => (
  <div
    className={styles.equalizer}
    data-active={active}
    data-quality={connectionQuality}
    data-miniature={miniature}
    aria-hidden
  >
    <span />
    <span />
    <span />
    <span />
  </div>
);

SideEqualizer.displayName = "SideEqualizer";
